import { Box, Divider, Flex, Link, Text } from '@chakra-ui/react';
import { BRAND_REDIRECT_LINK } from 'constants/links';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useDocumentFonts } from './DocumentFonts';
import { FONT_FAMILIES } from './FontFamilySelect.config';
import { FontListOption } from './FontListOption';
import { BRAND_FONT_LIST_ID } from './SelectList.config';

interface FontFamilySelectMenuBrandProps {
  fontFamily: string;
}

export const FontFamilySelectMenuBrand = ({ fontFamily }: FontFamilySelectMenuBrandProps) => {
  const { t } = useTranslation('editor_toolbar');
  const brandFontHeading = t('fontFamily.brandFontHeading');
  const brandFontGateMsg = t('fontFamily.brandFontGate');

  const { brandFonts, brandOptions } = useDocumentFonts();

  return (
    <>
      <Flex px={3} justifyContent='space-between' alignItems='center'>
        <Text fontSize='xs' color='font.300'>
          {brandFontHeading}
        </Text>
        {brandOptions}
      </Flex>
      {!!brandFonts.length && <BrandFontOptionList fontFamily={fontFamily} />}
      {!brandFonts.length && <BrandKitLink brandFontGateMsg={brandFontGateMsg} />}
      <Box px={3}>
        <Divider />
      </Box>
    </>
  );
};

interface BrandFontOptionListProps {
  // Current selected font
  fontFamily: string;
}

export const BrandFontOptionList = memo(({ fontFamily }: BrandFontOptionListProps) => {
  const { customFontsMap, brandFonts } = useDocumentFonts();

  return (
    <Flex id={BRAND_FONT_LIST_ID} direction='column' px={4}>
      {brandFonts.map((brandFontFamily) => {
        const defaultFontUrl = FONT_FAMILIES.find((checkingFont) => checkingFont.value === brandFontFamily)?.image_url;
        const customFontUrl =
          customFontsMap && customFontsMap.get(brandFontFamily)
            ? `data:image/png;base64,${customFontsMap.get(brandFontFamily)!.image_base64}`
            : '';

        return (
          <FontListOption
            key={brandFontFamily}
            value={brandFontFamily}
            imageUrl={defaultFontUrl || customFontUrl}
            isSelected={brandFontFamily === fontFamily}
            isBrandFont
          />
        );
      })}
    </Flex>
  );
});
BrandFontOptionList.displayName = 'BrandFontOptionList';

const BrandKitLink = ({ brandFontGateMsg }: { brandFontGateMsg: string }) => {
  return (
    <Link
      variant='inline'
      px='4'
      fontSize='xs'
      marginBottom='2'
      href={BRAND_REDIRECT_LINK}
      target='_blank'
      rel='noopener noreferrer'
    >
      {brandFontGateMsg}
    </Link>
  );
};
